import { render, staticRenderFns } from "./burerSubmitOutcome.vue?vue&type=template&id=f2201dd0&scoped=true"
import script from "./burerSubmitOutcome.vue?vue&type=script&lang=js"
export * from "./burerSubmitOutcome.vue?vue&type=script&lang=js"
import style0 from "./burerSubmitOutcome.vue?vue&type=style&index=0&id=f2201dd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2201dd0",
  null
  
)

export default component.exports